import { ModelOptions } from './model-options';

export class Fda2579FormModelOptions extends ModelOptions {
    public readonly required: boolean;

    public constructor({ required = true }: { required?: boolean } = {}) {
        super();
        this.required = required;
    }
}

export class Fda2579FormModelOptionsFromJson extends Fda2579FormModelOptions {
    public constructor(data: JsonFda2579FormModelOptions) {
        super({ required: data.required });
    }
}

export interface JsonFda2579FormModelOptions {
    required: boolean;
}
